import axios from 'axios'
import { getBaseAPIUrl } from './config'
import store from './store'
import { getStoredUtmMarks } from './router';
// import {IS_PRODUCTION} from '@/constants/isProduction'

export const baseURL = getBaseAPIUrl()

let instance = axios.create({
  baseURL: baseURL,
  timeout: 10 * 60 * 1000,
})


instance.interceptors.request.use(function (config) {
  const currentLocale = store.state.currentLocale;
  const currentCurrency = store.state.currentCurrency;
  const token = store.state.user.token;
  const refCode = store.state.user?.profile?.referal_code || window.localStorage.getItem('referralCode');

  const utmMarks = getStoredUtmMarks();
  if (utmMarks) {
    config.params = { ...config.params, utm: utmMarks };
  }

  if (refCode) {
    config.headers.common['X-Ref-Code'] = refCode
  }

  if (currentLocale) {
    config.headers.common['X-App-Locale'] = currentLocale
  }

  if (currentCurrency) {
    config.headers.common['X-App-Currency'] = currentCurrency.id
  }

  if (token) {
    config.headers.common['X-Customer-Token'] = token
  }

  return config;
});

instance.interceptors.response.use(function (res) {
  return res;
});

// function checkBasisAuth() {
//   // const user = 'comjobian';
//   // const password = '5mpKFQZmDj';
//   //
//   // const hash = btoa(user + ':' + password);
//
//   instance.get('api/helper/available-languages', {
//     // headers: {
//     //   'authorization': `Basic ${hash}`
//     // },
//   }).then(({data}) => {
//     console.log(data)
//   })
// }
//
// checkBasisAuth()

export const http = instance
